unit PlayListBuilder;

{ PlayStream - listläget: söka låtar, provlyssna (max 10 sek) och bygga/spara spellistor.
  Ingen speltid räknas här. }

interface

uses
  System.SysUtils, JS, Web, XData.Web.Client;

const
  PREVIEW_SECS = 10;

type
  TListBuilder = class
  private
    FClient: TXDataWebClient;
    FServerUrl: string;
    FResults: TJSArray;   // sökresultat
    FSongs: TJSArray;     // låtarna i listan som byggs
    FListId: Integer;     // 0 = ny lista som inte sparats
    FDirty: Boolean;      // osparade ändringar
    FPreviewId: Integer;  // låt-id som provlyssnas (0 = ingen)
    FPreviewTimer: NativeInt;
    FBound: Boolean;
    FDragFrom: string;    // 'lbResults' eller 'lbList' medan något dras
    FDragIdx: Integer;    // index i källan
    FDropIdx: Integer;    // var i listan det släpps (-1 = ingenstans)

    function El(const AId: string): TJSHTMLElement;
    procedure SetText(const AId, AText: string);
    procedure Bind(const AId, AEvent: string; AHandler: TJSEventHandler);
    function Esc(const S: string): string;
    function SongCells(O: TJSObject): string;
    function Val(const AId: string): string;
    function ParseValue(Response: TXDataClientResponse): string;
    procedure Msg(const AText: string);

    procedure Search;
    procedure RenderResults;
    procedure RenderList;
    procedure LoadPlaylists(ASelectId: Integer);
    procedure LoadPlaylist(AId: Integer);
    procedure NewList;
    procedure Save;
    procedure DeleteList;
    procedure AddSong(AIndex: Integer);
    procedure PreviewSong(AId: Integer);
    procedure StopPreview;
    procedure MarkPreviewRows;
    procedure AddAll;
    procedure SortByTempo(Asc: Boolean);
    procedure ClearDropMarks;

    function SearchClick(Event: TJSEvent): Boolean;
    function SearchKey(Event: TJSEvent): Boolean;
    function ResultsClick(Event: TJSEvent): Boolean;
    function ListClick(Event: TJSEvent): Boolean;
    function SaveClick(Event: TJSEvent): Boolean;
    function NewClick(Event: TJSEvent): Boolean;
    function DeleteClick(Event: TJSEvent): Boolean;
    function PickChange(Event: TJSEvent): Boolean;
    function NameInput(Event: TJSEvent): Boolean;
    function PreviewEnded(Event: TJSEvent): Boolean;
    procedure PreviewTimeout;
    function AddAllClick(Event: TJSEvent): Boolean;
    function SortAscClick(Event: TJSEvent): Boolean;
    function SortDescClick(Event: TJSEvent): Boolean;
    function DragStart(Event: TJSEvent): Boolean;
    function DragOver(Event: TJSEvent): Boolean;
    function DragDrop(Event: TJSEvent): Boolean;
    function DragEnd(Event: TJSEvent): Boolean;
  public
    constructor Create(AClient: TXDataWebClient; const AServerUrl: string);
    procedure Open(AStiles: TJSArray);
    procedure Close;
  end;

implementation

{ ---------- Hjälpare ---------- }

constructor TListBuilder.Create(AClient: TXDataWebClient; const AServerUrl: string);
begin
  inherited Create;
  FClient := AClient;
  FServerUrl := AServerUrl;
  FResults := TJSArray.new;
  FSongs := TJSArray.new;
end;

function TListBuilder.El(const AId: string): TJSHTMLElement;
begin
  Result := TJSHTMLElement(document.getElementById(AId));
end;

procedure TListBuilder.SetText(const AId, AText: string);
var
  E: TJSHTMLElement;
begin
  E := El(AId);
  if Assigned(E) then
    E.innerText := AText;
end;

procedure TListBuilder.Bind(const AId, AEvent: string; AHandler: TJSEventHandler);
var
  E: TJSHTMLElement;
begin
  E := El(AId);
  if Assigned(E) then
    E.addEventListener(AEvent, AHandler);
end;

// Stilbokstäverna (från filnamnet, t.ex. "BW") | tempo | titel – artist
function TListBuilder.SongCells(O: TJSObject): string;
var
  F, Letters: string;
  P: Integer;
begin
  Letters := '';
  if isString(O['file']) then
  begin
    F := string(O['file']);
    P := Pos('-', F);
    if (P > 1) and (P <= 4) then
      Letters := Copy(F, 1, P - 1);
  end;
  Result := '<span class="lb-s">' + Esc(Letters) + '</span>' +
    '<span class="lb-t">' + IntToStr(toInteger(O['tempo'])) + '</span>' +
    '<span class="lb-n">' + Esc(string(O['title'])) +
    ' <span class="lb-a">– ' + Esc(string(O['artist'])) + '</span></span>';
end;

function TListBuilder.Esc(const S: string): string;
begin
  Result := StringReplace(S, '&', '&amp;', [rfReplaceAll]);
  Result := StringReplace(Result, '<', '&lt;', [rfReplaceAll]);
  Result := StringReplace(Result, '>', '&gt;', [rfReplaceAll]);
  Result := StringReplace(Result, '"', '&quot;', [rfReplaceAll]);
end;

function TListBuilder.Val(const AId: string): string;
begin
  Result := '';
  asm
    var e = document.getElementById(AId);
    if (e) Result = e.value;
  end;
end;

function TListBuilder.ParseValue(Response: TXDataClientResponse): string;
var
  Obj: TJSObject;
begin
  Obj := TJSObject(TJSJSON.parse(Response.ResponseText));
  Result := string(Obj['value']);
end;

procedure TListBuilder.Msg(const AText: string);
begin
  SetText('lbMsg', AText);
end;

{ ---------- Öppna / stäng ---------- }

procedure TListBuilder.Open(AStiles: TJSArray);
var
  i: Integer;
  O: TJSObject;
  H: string;
begin
  if not FBound then
  begin
    FBound := True;
    Bind('lbSearchBtn', 'click', @SearchClick);
    Bind('lbText', 'keydown', @SearchKey);
    Bind('lbTMin', 'keydown', @SearchKey);
    Bind('lbTMax', 'keydown', @SearchKey);
    Bind('lbResults', 'click', @ResultsClick);
    Bind('lbList', 'click', @ListClick);
    Bind('lbSave', 'click', @SaveClick);
    Bind('lbNew', 'click', @NewClick);
    Bind('lbDelete', 'click', @DeleteClick);
    Bind('lbPick', 'change', @PickChange);
    Bind('lbName', 'input', @NameInput);
    Bind('lbPreview', 'ended', @PreviewEnded);
    Bind('lbAddAll', 'click', @AddAllClick);
    Bind('lbSortAsc', 'click', @SortAscClick);
    Bind('lbSortDesc', 'click', @SortDescClick);
    // Dra och släpp: från sökresultaten till listan, och inom listan
    Bind('lbResults', 'dragstart', @DragStart);
    Bind('lbResults', 'dragend', @DragEnd);
    Bind('lbList', 'dragstart', @DragStart);
    Bind('lbList', 'dragend', @DragEnd);
    Bind('lbList', 'dragover', @DragOver);
    Bind('lbList', 'drop', @DragDrop);
  end;

  // Stilar i sökfältet
  H := '<option value="0">Alla stilar</option>';
  if Assigned(AStiles) then
    for i := 0 to AStiles.length - 1 do
    begin
      O := TJSObject(AStiles[i]);
      H := H + '<option value="' + IntToStr(toInteger(O['id'])) + '">' +
        Esc(string(O['name'])) + '</option>';
    end;
  El('lbDance').innerHTML := H;

  if FListId = 0 then
    NewList;
  LoadPlaylists(FListId);
  Msg('');
end;

procedure TListBuilder.Close;
begin
  StopPreview;
end;

{ ---------- Sökning ---------- }

procedure TListBuilder.Search;
begin
  Msg('Söker...');
  FClient.RawInvoke('IPlayService.SearchSongs',
    [Trim(Val('lbText')), StrToIntDef(Val('lbDance'), 0),
     StrToIntDef(Val('lbTMin'), 0), StrToIntDef(Val('lbTMax'), 0)],
    procedure(Response: TXDataClientResponse)
    begin
      FResults := TJSArray(TJSJSON.parse(ParseValue(Response)));
      RenderResults;
      if FResults.length = 0 then
        Msg('Inga låtar hittades.')
      else if FResults.length >= 300 then
        Msg('Visar de första 300 träffarna. Gör sökningen smalare.')
      else
        Msg('');
    end,
    procedure(Error: TXDataClientError)
    begin
      Msg('Sökningen misslyckades: ' + Error.ErrorMessage);
    end);
end;

procedure TListBuilder.RenderResults;
var
  i: Integer;
  O: TJSObject;
  H: string;
begin
  H := '';
  for i := 0 to FResults.length - 1 do
  begin
    O := TJSObject(FResults[i]);
    H := H + '<li draggable="true" data-i="' + IntToStr(i) + '" data-id="' + IntToStr(toInteger(O['id'])) + '">' +
      '<button class="ps-btn lb-ic" data-act="play" title="Provlyssna ' + IntToStr(PREVIEW_SECS) + ' sek">▶</button>' +
      SongCells(O) +
      '<button class="ps-btn lb-ic lb-add" data-act="add" title="Lägg till i listan">+</button>' +
      '</li>';
  end;
  El('lbResults').innerHTML := H;
  SetText('lbResCount', IntToStr(FResults.length) + ' träffar');
  MarkPreviewRows;
end;

{ ---------- Listan ---------- }

procedure TListBuilder.RenderList;
var
  i: Integer;
  O: TJSObject;
  H: string;
begin
  H := '';
  for i := 0 to FSongs.length - 1 do
  begin
    O := TJSObject(FSongs[i]);
    H := H + '<li draggable="true" data-i="' + IntToStr(i) + '" data-id="' + IntToStr(toInteger(O['id'])) + '">' +
      '<span class="lb-nr">' + IntToStr(i + 1) + '</span>' +
      '<button class="ps-btn lb-ic" data-act="play" title="Provlyssna ' + IntToStr(PREVIEW_SECS) + ' sek">▶</button>' +
      SongCells(O) +
      '<span class="lb-move">' +
        '<button class="ps-btn lb-ic" data-act="up" title="Flytta upp">↑</button>' +
        '<button class="ps-btn lb-ic" data-act="down" title="Flytta ner">↓</button>' +
        '<button class="ps-btn lb-ic lb-del" data-act="del" title="Ta bort">✕</button>' +
      '</span></li>';
  end;
  if FSongs.length = 0 then
    H := '<li class="lb-empty">Dra hit låtar från sökresultatet,<br>eller tryck + eller "Lägg alla i listan".</li>';
  El('lbList').innerHTML := H;
  if FDirty then
    SetText('lbCount', IntToStr(FSongs.length) + ' låtar – ej sparad')
  else
    SetText('lbCount', IntToStr(FSongs.length) + ' låtar');
  MarkPreviewRows;
end;

procedure TListBuilder.AddSong(AIndex: Integer);
begin
  if (AIndex < 0) or (AIndex >= FResults.length) then
    Exit;
  FSongs.push(FResults[AIndex]);
  FDirty := True;
  RenderList;
  // Visa den nya raden längst ner
  asm
    var l = document.getElementById('lbList');
    if (l) l.scrollTop = l.scrollHeight;
  end;
end;

procedure TListBuilder.NewList;
begin
  FListId := 0;
  FSongs := TJSArray.new;
  FDirty := False;
  TJSHTMLInputElement(El('lbName')).value := '';
  TJSHTMLSelectElement(El('lbPick')).value := '0';
  RenderList;
end;

procedure TListBuilder.LoadPlaylists(ASelectId: Integer);
begin
  FClient.RawInvoke('IPlayService.GetPlaylists', [],
    procedure(Response: TXDataClientResponse)
    var
      Arr: TJSArray;
      O: TJSObject;
      i: Integer;
      H: string;
    begin
      Arr := TJSArray(TJSJSON.parse(ParseValue(Response)));
      H := '<option value="0">– Ny lista –</option>';
      for i := 0 to Arr.length - 1 do
      begin
        O := TJSObject(Arr[i]);
        H := H + '<option value="' + IntToStr(toInteger(O['id'])) + '">' +
          Esc(string(O['name'])) + ' (' + IntToStr(toInteger(O['count'])) + ')</option>';
      end;
      El('lbPick').innerHTML := H;
      TJSHTMLSelectElement(El('lbPick')).value := IntToStr(ASelectId);
    end,
    procedure(Error: TXDataClientError)
    begin
      Msg('Kunde inte hämta listorna: ' + Error.ErrorMessage);
    end);
end;

procedure TListBuilder.LoadPlaylist(AId: Integer);
begin
  FClient.RawInvoke('IPlayService.GetPlaylist', [AId],
    procedure(Response: TXDataClientResponse)
    var
      O: TJSObject;
    begin
      O := TJSObject(TJSJSON.parse(ParseValue(Response)));
      if not O.hasOwnProperty('id') then
      begin
        Msg('Listan finns inte längre.');
        LoadPlaylists(0);
        NewList;
        Exit;
      end;
      FListId := toInteger(O['id']);
      FSongs := TJSArray(O['songs']);
      FDirty := False;
      TJSHTMLInputElement(El('lbName')).value := string(O['name']);
      RenderList;
      Msg('');
    end,
    procedure(Error: TXDataClientError)
    begin
      Msg('Kunde inte hämta listan: ' + Error.ErrorMessage);
    end);
end;

procedure TListBuilder.Save;
var
  Name, Ids: string;
  i: Integer;
begin
  Name := Trim(Val('lbName'));
  if Name = '' then
  begin
    Msg('Skriv ett namn på listan först.');
    El('lbName').focus;
    Exit;
  end;
  Ids := '';
  for i := 0 to FSongs.length - 1 do
  begin
    if i > 0 then
      Ids := Ids + ',';
    Ids := Ids + IntToStr(toInteger(TJSObject(FSongs[i])['id']));
  end;
  Msg('Sparar...');
  FClient.RawInvoke('IPlayService.SavePlaylist', [FListId, Name, Ids],
    procedure(Response: TXDataClientResponse)
    var
      R: string;
    begin
      R := ParseValue(Response);
      if Copy(R, 1, 4) = 'FEL:' then
      begin
        Msg(R);
        Exit;
      end;
      FListId := StrToIntDef(R, 0);
      FDirty := False;
      RenderList;
      LoadPlaylists(FListId);
      Msg('Listan "' + Name + '" är sparad.');
    end,
    procedure(Error: TXDataClientError)
    begin
      Msg('Kunde inte spara: ' + Error.ErrorMessage);
    end);
end;

procedure TListBuilder.DeleteList;
var
  Ok: Boolean;
begin
  if FListId = 0 then
  begin
    NewList;
    Exit;
  end;
  Ok := False;
  asm
    Ok = window.confirm('Ta bort listan för gott?');
  end;
  if not Ok then
    Exit;
  FClient.RawInvoke('IPlayService.DeletePlaylist', [FListId],
    procedure(Response: TXDataClientResponse)
    begin
      NewList;
      LoadPlaylists(0);
      Msg('Listan är borttagen.');
    end,
    procedure(Error: TXDataClientError)
    begin
      Msg('Kunde inte ta bort: ' + Error.ErrorMessage);
    end);
end;

{ ---------- Provlyssning (max 10 sek) ---------- }

procedure TListBuilder.PreviewSong(AId: Integer);
var
  Url: string;
begin
  if FPreviewId = AId then
  begin
    StopPreview; // samma knapp igen = stopp
    Exit;
  end;
  StopPreview;
  FPreviewId := AId;
  Url := FServerUrl + '/media/preview/' + IntToStr(AId);
  asm
    var a = document.getElementById('lbPreview');
    a.src = Url;
    var p = a.play();
    if (p && p.catch) p.catch(function(e){ console.log('preview:', e); });
  end;
  FPreviewTimer := window.setTimeout(@PreviewTimeout, PREVIEW_SECS * 1000);
  MarkPreviewRows;
end;

procedure TListBuilder.StopPreview;
begin
  if FPreviewTimer <> 0 then
    window.clearTimeout(FPreviewTimer);
  FPreviewTimer := 0;
  FPreviewId := 0;
  asm
    var a = document.getElementById('lbPreview');
    if (a) { a.pause(); a.removeAttribute('src'); a.load(); }
  end;
  MarkPreviewRows;
end;

procedure TListBuilder.PreviewTimeout;
begin
  FPreviewTimer := 0;
  StopPreview;
end;

function TListBuilder.PreviewEnded(Event: TJSEvent): Boolean;
begin
  StopPreview;
  Result := True;
end;

procedure TListBuilder.MarkPreviewRows;
var
  Id: Integer;
begin
  Id := FPreviewId;
  asm
    var rows = document.querySelectorAll('#lbResults li, #lbList li');
    for (var i = 0; i < rows.length; i++) {
      var on = (parseInt(rows[i].dataset.id) === Id) && Id !== 0;
      rows[i].classList.toggle('lb-playing', on);
      var b = rows[i].querySelector('[data-act="play"]');
      if (b) b.textContent = on ? '■' : '▶';
    }
  end;
end;

{ ---------- Lägg alla / sortera ---------- }

procedure TListBuilder.AddAll;
var
  i, Added, Skipped: Integer;
  Has: TJSObject;
  Key: string;
begin
  if FResults.length = 0 then
  begin
    Msg('Sök fram några låtar först.');
    Exit;
  end;
  Has := TJSObject.new;
  for i := 0 to FSongs.length - 1 do
    Has[IntToStr(toInteger(TJSObject(FSongs[i])['id']))] := True;
  Added := 0;
  Skipped := 0;
  for i := 0 to FResults.length - 1 do
  begin
    Key := IntToStr(toInteger(TJSObject(FResults[i])['id']));
    if Has.hasOwnProperty(Key) then
      Inc(Skipped)
    else
    begin
      FSongs.push(FResults[i]);
      Has[Key] := True;
      Inc(Added);
    end;
  end;
  if Added > 0 then
    FDirty := True;
  RenderList;
  asm
    var l = document.getElementById('lbList');
    if (l) l.scrollTop = l.scrollHeight;
  end;
  if Skipped > 0 then
    Msg(IntToStr(Added) + ' låtar tillagda, ' + IntToStr(Skipped) + ' fanns redan i listan.')
  else
    Msg(IntToStr(Added) + ' låtar tillagda.');
end;

procedure TListBuilder.SortByTempo(Asc: Boolean);
var
  Arr: TJSArray;
begin
  if FSongs.length < 2 then
    Exit;
  Arr := FSongs;
  asm
    Arr.sort(function (a, b) {
      var d = (parseInt(a.tempo) || 0) - (parseInt(b.tempo) || 0);
      return Asc ? d : -d;
    });
  end;
  FDirty := True;
  RenderList;
  if Asc then
    Msg('Sorterad på tempo, låg till hög.')
  else
    Msg('Sorterad på tempo, hög till låg.');
end;

{ ---------- Dra och släpp ---------- }

procedure TListBuilder.ClearDropMarks;
begin
  asm
    var l = document.getElementById('lbList');
    if (l) {
      l.classList.remove('lb-drop-end');
      var m = l.querySelectorAll('.lb-drop-before, .lb-drop-after');
      for (var k = 0; k < m.length; k++) m[k].classList.remove('lb-drop-before', 'lb-drop-after');
    }
  end;
end;

function TListBuilder.DragStart(Event: TJSEvent): Boolean;
var
  Src: string;
  Idx: Integer;
begin
  Src := '';
  Idx := -1;
  asm
    var li = (Event.target && Event.target.closest) ? Event.target.closest('li[data-i]') : null;
    if (li) {
      Idx = parseInt(li.dataset.i);
      Src = li.parentElement.id;
      if (Event.dataTransfer) {
        Event.dataTransfer.setData('text/plain', li.dataset.id);
        Event.dataTransfer.effectAllowed = 'copyMove';
      }
      li.classList.add('lb-dragging');
    }
  end;
  FDragFrom := Src;
  FDragIdx := Idx;
  FDropIdx := -1;
  Result := True;
end;

function TListBuilder.DragOver(Event: TJSEvent): Boolean;
var
  From: string;
  Idx: Integer;
begin
  From := FDragFrom;
  Idx := -1;
  if From = '' then
    Exit(True); // något annat än en låt dras över listan
  asm
    Event.preventDefault();
    var l = document.getElementById('lbList');
    l.classList.remove('lb-drop-end');
    var m = l.querySelectorAll('.lb-drop-before, .lb-drop-after');
    for (var k = 0; k < m.length; k++) m[k].classList.remove('lb-drop-before', 'lb-drop-after');
    var li = (Event.target && Event.target.closest) ? Event.target.closest('li[data-i]') : null;
    if (li && l.contains(li)) {
      var r = li.getBoundingClientRect();
      var i = parseInt(li.dataset.i);
      if (Event.clientY > r.top + r.height / 2) { Idx = i + 1; li.classList.add('lb-drop-after'); }
      else { Idx = i; li.classList.add('lb-drop-before'); }
    } else {
      Idx = l.querySelectorAll('li[data-i]').length;
      l.classList.add('lb-drop-end');
    }
    if (Event.dataTransfer) Event.dataTransfer.dropEffect = (From === 'lbList') ? 'move' : 'copy';
  end;
  FDropIdx := Idx;
  Result := True;
end;

function TListBuilder.DragDrop(Event: TJSEvent): Boolean;
var
  ToIdx, FromIdx: Integer;
  Item: JSValue;
begin
  asm
    Event.preventDefault();
  end;
  ClearDropMarks;
  ToIdx := FDropIdx;
  FromIdx := FDragIdx;
  if (ToIdx < 0) or (ToIdx > FSongs.length) then
    Exit(True);

  if FDragFrom = 'lbResults' then
  begin
    if (FromIdx < 0) or (FromIdx >= FResults.length) then
      Exit(True);
    FSongs.splice(ToIdx, 0, FResults[FromIdx]);
  end
  else if FDragFrom = 'lbList' then
  begin
    if (FromIdx < 0) or (FromIdx >= FSongs.length) then
      Exit(True);
    if (ToIdx = FromIdx) or (ToIdx = FromIdx + 1) then
      Exit(True); // släppt på samma plats
    Item := FSongs[FromIdx];
    FSongs.splice(FromIdx, 1);
    if ToIdx > FromIdx then
      Dec(ToIdx);
    FSongs.splice(ToIdx, 0, Item);
  end
  else
    Exit(True);

  FDragFrom := '';
  FDirty := True;
  RenderList;
  Result := True;
end;

function TListBuilder.DragEnd(Event: TJSEvent): Boolean;
begin
  ClearDropMarks;
  asm
    var d = document.querySelectorAll('.lb-dragging');
    for (var k = 0; k < d.length; k++) d[k].classList.remove('lb-dragging');
  end;
  FDragFrom := '';
  FDropIdx := -1;
  Result := True;
end;

function TListBuilder.AddAllClick(Event: TJSEvent): Boolean;
begin
  AddAll;
  Result := True;
end;

function TListBuilder.SortAscClick(Event: TJSEvent): Boolean;
begin
  SortByTempo(True);
  Result := True;
end;

function TListBuilder.SortDescClick(Event: TJSEvent): Boolean;
begin
  SortByTempo(False);
  Result := True;
end;

{ ---------- Händelser ---------- }

function TListBuilder.SearchClick(Event: TJSEvent): Boolean;
begin
  Search;
  Result := True;
end;

function TListBuilder.SearchKey(Event: TJSEvent): Boolean;
var
  K: Integer;
begin
  K := 0;
  asm
    K = Event.keyCode;
  end;
  if K = 13 then
    Search;
  Result := True;
end;

function TListBuilder.ResultsClick(Event: TJSEvent): Boolean;
var
  Act: string;
  Idx, Id: Integer;
begin
  Act := '';
  Idx := -1;
  Id := 0;
  asm
    var b = Event.target.closest('[data-act]');
    var li = Event.target.closest('li[data-i]');
    if (b) Act = b.dataset.act;
    if (li) { Idx = parseInt(li.dataset.i); Id = parseInt(li.dataset.id); }
  end;
  if Act = 'play' then
    PreviewSong(Id)
  else if Act = 'add' then
    AddSong(Idx);
  Result := True;
end;

function TListBuilder.ListClick(Event: TJSEvent): Boolean;
var
  Act: string;
  Idx, Id: Integer;
  Tmp: JSValue;
begin
  Act := '';
  Idx := -1;
  Id := 0;
  asm
    var b = Event.target.closest('[data-act]');
    var li = Event.target.closest('li[data-i]');
    if (b) Act = b.dataset.act;
    if (li) { Idx = parseInt(li.dataset.i); Id = parseInt(li.dataset.id); }
  end;
  if (Idx < 0) or (Idx >= FSongs.length) then
    Exit(True);

  if Act = 'play' then
  begin
    PreviewSong(Id);
    Exit(True);
  end
  else if (Act = 'up') and (Idx > 0) then
  begin
    Tmp := FSongs[Idx - 1];
    FSongs[Idx - 1] := FSongs[Idx];
    FSongs[Idx] := Tmp;
  end
  else if (Act = 'down') and (Idx < FSongs.length - 1) then
  begin
    Tmp := FSongs[Idx + 1];
    FSongs[Idx + 1] := FSongs[Idx];
    FSongs[Idx] := Tmp;
  end
  else if Act = 'del' then
    FSongs.splice(Idx, 1)
  else
    Exit(True);

  FDirty := True;
  RenderList;
  Result := True;
end;

function TListBuilder.SaveClick(Event: TJSEvent): Boolean;
begin
  Save;
  Result := True;
end;

function TListBuilder.NewClick(Event: TJSEvent): Boolean;
var
  Ok: Boolean;
begin
  Ok := True;
  if FDirty then
    asm
      Ok = window.confirm('Listan har osparade ändringar. Börja på en ny ändå?');
    end;
  if Ok then
  begin
    NewList;
    Msg('');
  end;
  Result := True;
end;

function TListBuilder.DeleteClick(Event: TJSEvent): Boolean;
begin
  DeleteList;
  Result := True;
end;

function TListBuilder.PickChange(Event: TJSEvent): Boolean;
var
  Id: Integer;
  Ok: Boolean;
begin
  Id := StrToIntDef(Val('lbPick'), 0);
  Ok := True;
  if FDirty then
    asm
      Ok = window.confirm('Listan har osparade ändringar. Byta lista ändå?');
    end;
  if not Ok then
  begin
    TJSHTMLSelectElement(El('lbPick')).value := IntToStr(FListId);
    Exit(True);
  end;
  if Id = 0 then
    NewList
  else
    LoadPlaylist(Id);
  Result := True;
end;

function TListBuilder.NameInput(Event: TJSEvent): Boolean;
begin
  FDirty := True;
  RenderList;
  Result := True;
end;

end.
